import type { FormEvent } from "react";

interface SubmittableForm {
  handleSubmit: () => unknown;
}

export function submitForm(form: SubmittableForm) {
  return (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    event.stopPropagation();
    void form.handleSubmit();
  };
}
